import React, { useState } from 'react';
import PaymentsCard from '../PaymentsCard/PaymentsCard';

import './futureEarnings.css';

export default function FutureEarnings({ futureEarnings }) {
  const [futureEarningsSelected, setFutureEarningsSelected] = useState('Monthly');
  const [displayFutureEarnings, setDisplayFutureEarnings] = useState(futureEarnings.highestMonthlyEarnings);

  const handleFutureEarningsSelected = (e) => {
    setFutureEarningsSelected(e.target.innerHTML);
    switch(e.target.innerHTML) {
      case 'Monthly':
        setDisplayFutureEarnings(futureEarnings.highestMonthlyEarnings);
        break;
      case 'Yearly':
        setDisplayFutureEarnings(futureEarnings.highestYearlyEarnings);
        break;
      default:
        setDisplayFutureEarnings('na');
    }
  };

  return (
    <PaymentsCard
      title="Potential Future Earnings"
      icon="coin"
      description="Potential per month"
      total={displayFutureEarnings}
      img="payments_bg_layer3"
    >
      <div>
        <div className="row no-gutters">
          <div className="col-6">
            <div className={futureEarningsSelected === 'Monthly' ? 'future-earnings-active' : 'future-earnings-inactive'}>
              <p
                className="font-weight-bold m-0 py-1"
                onClick={handleFutureEarningsSelected}
              >
                Monthly
              </p>
            </div>
          </div>
          <div className="col-6">
            <div className={futureEarningsSelected === 'Yearly' ? 'future-earnings-active' : 'future-earnings-inactive'}>
              <p
                className="font-weight-bold m-0 py-1"
                onClick={handleFutureEarningsSelected}
              >
                Yearly
              </p>
            </div>
          </div>
        </div>
        <div>
          <p className="text-left ml-2 mt-3">
            If you continued doing great work at the rate of your best month ({futureEarnings.highestMonthlyEarningsMonthYear}), you could make:
          </p>
        </div>
      </div>
    </PaymentsCard>
  )
}
